// Updated for Vercel deployment - 2024
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Resume from './pages/Resume';
import Journal from './pages/Journal';
import Shop from './pages/Shop'
import Code from './pages/Code'
import Books from './pages/Books'
import Shoproject from './pages/Shoproject'
import Research from './pages/Research'
import Toprectangle from './components/Toprectangle';
import Bottomrectangle from './components/Bottomrectangle';
import Weed from './components/Weed';
import Chat from './components/Chat';
import Copyright from './components/Copyright';
import Optionsicon from './components/Optionsicon';
import Options from './components/Options';
import Dashboard from './pages/Dashboard';
import { trackPageView } from './utils/analyticsUtils';

// Component to track page views
const PageTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    const pageName = location.pathname === '/' ? 'Home' : location.pathname.substring(1);
    trackPageView(pageName);
  }, [location]);
  
  return null;
};

function App() {
  return (
    <Router>
      <PageTracker />
      <Weed />
      <Navbar />
      <Toprectangle />
      <Optionsicon />
      <Options />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/code" element={<Code />} />
        <Route path="/books" element={<Books />} />
        <Route path="/shoproject" element={<Shoproject />} />
        <Route path="/research" element={<Research />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
      <Chat />
      <Bottomrectangle />
      <Copyright />
    </Router>
  );
}

export default App;
